module.exports = __webpack_public_path__ + "img/contract-icon.c629d8a5.png";